<template>
  <div class="other-details-form">

    <b-modal :active.sync="showAddDetailModal">
      <article class="message is-info">
        <div class="message-header">
          <p>Add Detail</p>
        </div>
        <div class="message-body">
          <b-field label="Detail Name">
            <b-input v-model="newDetailName"></b-input>
          </b-field>
          <button class="button is-success" @click="addDetail">Add</button>
          &nbsp;
          <button class="button" @click="showAddDetailModal = false">Cancel</button>
        </div>
      </article>
    </b-modal>

    <b-field v-for="(detail, index) in details" :key="index" :label="detail.key">
      <div class="flex">
        <div class="flex-1">
          <b-input v-model="detail.value"></b-input>
        </div>
        <button class="button margin-left" @click="removeDetail(index)"><i class="fas fa-times"></i></button>
      </div>
    </b-field>

    <button class="button" @click="showAddDetailModal = true">Add Detail</button>
  </div>
</template>

<script>
export default {
  name: 'OtherDetailsForm',
  props: ['details'],
  data () {
    return {
      showAddDetailModal: false,
      newDetailName: ''
    }
  },
  methods: {
    addDetail () {
      if (!this.newDetailName.length) {
        return
      }
      if (!this.details) {
        this.details = []
      }
      this.details.push({ key: this.newDetailName, value: '' })
      this.newDetailName = ''
      this.showAddDetailModal = false
    },
    removeDetail (index) {
      this.details.splice(index, 1)
    }
  }
}
</script>

<style>

</style>
